<template>
    <div class="modal fade" id="modalEditionLabel" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                    <h4 class="modal-title">
                        <i class="fa fa-tag" :class="getLabelClass(label.label)"></i>
                        Modifier le label {{ label.label }}
                    </h4>
                </div>
                <div class="modal-body">
                    <div class="alert alert-danger" v-if="messagesErreur.length">
                        <i class="fa fa-exclamation-triangle"></i>
                        <span v-if="messagesErreur.length === 1">{{ messagesErreur[0] }}</span>
                        <ul v-else class="liste-erreurs">
                            <li v-for="(message, index) in messagesErreur" :key="index">{{ message }}</li>
                        </ul>
                    </div>
                    <form @submit.prevent="submitForm">
                        <div class="form-group">
                            <label>Niveau du label</label>
                            <select class="form-control" v-model="formData.niveau" required>
                                <option v-for="n in [1, 2, 3]" :key="n" :value="n">
                                    {{ n }} étoile{{ n > 1 ? 's' : '' }}
                                </option>
                            </select>
                        </div>
                        <div class="form-group">
                            <label>Date de début</label>
                            <input type="date" class="form-control" v-model="formData.date_debut" required>
                        </div>
                        <div class="form-group">
                            <label>Date de fin</label>
                            <input type="date" class="form-control" v-model="formData.date_fin" required>
                        </div>
                        <div class="form-group">
                            <label>Commentaire (optionnel)</label>
                            <textarea class="form-control" v-model="formData.commentaire" rows="3"></textarea>
                        </div>
                    </form>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-default" data-dismiss="modal">Annuler</button>
                    <button type="button" class="btn btn-primary" @click="submitForm" :disabled="loading || !formData.niveau">
                        <i class="fa" :class="loading ? 'fa-spinner fa-spin' : 'fa-save'"></i>
                        Enregistrer
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
    name: 'ModalEditionLabel',
    props: {
        label: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            loading: false,
            messagesErreur: [],
            formData: {
                niveau: null,
                date_debut: '',
                date_fin: '',
                commentaire: ''
            }
        }
    },
    mounted() {
        this.initialiserFormulaire();
        // v-if côté parent : on prévient à la fermeture pour que le composant soit
        // détruit et réinitialisé au prochain label édité
        $('#modalEditionLabel').on('hidden.bs.modal', () => {
            this.$emit('fermer');
        });
    },
    methods: {
        initialiserFormulaire() {
            this.formData.niveau = parseInt(this.label.niveau, 10) || null;
            this.formData.date_debut = this.formatPourInputDate(this.label.date_debut);
            this.formData.date_fin = this.formatPourInputDate(this.label.date_fin);
            this.formData.commentaire = this.label.commentaire || '';
        },
        // Les dates arrivent en datetime ("2025-05-15 00:00:00"), les inputs date veulent du YYYY-MM-DD
        formatPourInputDate(date) {
            if (!date) return '';
            return String(date).split(' ')[0].split('T')[0];
        },
        getLabelClass(labelNom) {
            switch(labelNom) {
                case 'Art Martial':
                    return 'label-art-martial';
                case 'Kyorugi':
                    return 'label-kyorugi';
                case 'Poomsae':
                    return 'label-poomsae';
                default:
                    return 'label-commun';
            }
        },
        // Remonte les messages de l'API : 409 métier, 422 validation, 404 introuvable
        extraireMessagesErreur(error) {
            const body = error && error.body ? error.body : null;
            if (body && body.errors) {
                const messages = Object.keys(body.errors)
                    .reduce((acc, champ) => acc.concat(body.errors[champ]), []);
                if (messages.length) return messages;
            }
            if (body && body.message) return [body.message];
            return ['Une erreur est survenue lors de la modification du label'];
        },
        submitForm() {
            this.loading = true;
            this.messagesErreur = [];
            const data = {
                niveau: parseInt(this.formData.niveau, 10),
                date_debut: this.formData.date_debut,
                date_fin: this.formData.date_fin,
                commentaire: this.formData.commentaire
            };

            this.$http.put(this.getRoute('Labelisation.updateClubLabel') + this.label.id, data)
                .then(() => {
                    $('#modalEditionLabel').modal('hide');
                    this.$emit('label-modifie');
                })
                .catch(error => {
                    console.error('Erreur lors de la modification du label:', error);
                    this.messagesErreur = this.extraireMessagesErreur(error);
                })
                .finally(() => {
                    this.loading = false;
                });
        }
    },
    computed: {
        ...mapGetters({
            getRoute: 'getRoute',
        })
    }
}
</script>

<style scoped>
.modal-title {
    display: flex;
    align-items: center;
    gap: 8px;
}

.modal-title i {
    font-size: 18px;
}

.label-art-martial {
    color: #007bff;
}

.label-kyorugi {
    color: #dc3545;
}

.label-poomsae {
    color: #6f42c1;
}

.form-group {
    margin-bottom: 15px;
}

.form-group label {
    font-weight: 500;
    margin-bottom: 5px;
}

textarea.form-control {
    resize: vertical;
    min-height: 80px;
}

.alert-danger i {
    margin-right: 6px;
}

.liste-erreurs {
    display: inline-block;
    margin: 0;
    padding-left: 20px;
    vertical-align: top;
}
</style>



// WEBPACK FOOTER //
// src/components/Secretariat/Club/ModalEditionLabel.vue